import React from "react";
import {
  Plan,
  OptionalBenefitPackage,
  PlanDetailsSection,
} from "../../../@types";
import { PlanDetailSection } from "../../../components";

import { CONSTANTS as C, useTranslate } from "../../../helpers";

const ExtraBenefits: React.FunctionComponent<{ plan: Plan }> = ({ plan }) => {
  const t = useTranslate();

  const optionalBenefits: OptionalBenefitPackage[] = plan.optional_benefits;

  const getBenefitCommaList = (benefits: string[]): string => {
    if (benefits.length > 1) {
      const head = benefits
        .map(benefit => t(C.optionalPackageBenefits[benefit]))
        .slice(0, benefits.length - 1)
        .join(", ");
      const tail = benefits
        .map(benefit => t(C.optionalPackageBenefits[benefit]))
        .slice(benefits.length - 1);

      return `${head}, and ${tail}`;
    }

    return t(C.optionalPackageBenefits[benefits[0]]);
  };

  return (
    <PlanDetailSection
      id={PlanDetailsSection.OPTIONAL_PACKAGES}
      title={t("optional_packages.title")}
    >
      <div className="OptBenefits">
        <div className="OptBenefits__description">
          {t("optional_packages.description")}
        </div>
        <div className="OptBenefits__packageList">
          {optionalBenefits.map(pkg => (
            <div key={pkg.package_number} className="OptBenefits__package">
              <div className="ds-l-col--12 ds-l-xl-col--6">
                <span>
                  <strong>
                    {t("optional_packages.package")} #{pkg.package_number}
                  </strong>
                  {` ${t("optional_packages.includes")} ${getBenefitCommaList(
                    pkg.benefits
                  )}`}
                </span>
              </div>
              <div className="ds-l-col--12 ds-l-xl-col--6">
                <span>
                  {t("optional_packages.monthly_premium")}:{" "}
                  <strong>{pkg.monthly_premium}</strong>
                </span>
                <br />
                <span>
                  {t("optional_packages.deductible")}:{" "}
                  <strong>{pkg.deductible}</strong>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PlanDetailSection>
  );
};

export default ExtraBenefits;
